(function(){
  'use strict';
  var root=document.getElementById('ccm');
  if(!root||root.classList.contains('ccs-enhanced'))return;
  var grid=root.querySelector('.ccm-grid');
  var tabs=root.querySelector('.ccm-tabs,[aria-label*="Categor"],[aria-label*="categ"],[aria-label*="Sample categories"]');
  function productPath(card){
    var link=card.querySelector('a[href*="/products/"]');
    if(!link)return '';
    try{return new URL(link.href,location.origin).pathname.replace(/\/$/,'').toLowerCase();}catch(error){return '';}
  }
  function isSamplePackController(card){
    return /\/products\/(?:paquete-de-muestras-b2b|pacchetto-campioni-b2b|b2b-sample-pack)$/.test(productPath(card));
  }
  var allCards=[].slice.call(root.querySelectorAll('.ccm-card'));
  var cards=allCards.filter(function(card){
    var excluded=isSamplePackController(card);
    if(excluded){card.hidden=true;card.setAttribute('aria-hidden','true');}
    return !excluded;
  });
  if(!grid||!tabs||!cards.length)return;

  var lang=(document.documentElement.lang||'').toLowerCase();
  var pathLocale=((location.pathname.match(/^\/(de|en|it|es)(?:\/|$)/i)||[])[1]||'').toLowerCase();
  var locale=pathLocale||lang.split(/[-_]/)[0];
  if(!/^(de|en|it|es)$/.test(locale))locale=location.hostname.indexOf('aperigusto')>-1?'it':(location.hostname.indexOf('donsnacks')>-1?'es':'de');
  var isIt=locale==='it';
  var isEs=locale==='es';
  var isEn=locale==='en';
  function tr(de,en,it,es){return isEn?en:(isIt?it:(isEs?es:de));}
  var filters=[
    ['glutenfree',tr('Glutenfrei','Gluten-free','Senza glutine','Sin gluten'),/(glutenfrei|gluten-free|senza glutine|sin gluten)/i],
    ['lactosefree',tr('Laktosefrei','Lactose-free','Senza lattosio','Sin lactosa'),/(laktosefrei|lactose-free|senza lattosio|sin lactosa)/i],
    ['vegetarian',tr('Vegetarisch','Vegetarian','Vegetariano','Vegetariano'),/(vegetarisch|vegetarian|vegetariano)/i],
    ['vegan',tr('Vegan','Vegan','Vegano','Vegano'),/(\bvegan\b|vegano)/i],
    ['nosalt',tr('Ohne Salzzusatz','No added salt','Senza sale aggiunto','Sin sal añadida'),/(ohne salzzusatz|no added salt|senza sale aggiunto|sin sal anadida)/i],
    ['nosugar',tr('Ohne Zuckerzusatz','No added sugar','Senza zuccheri aggiunti','Sin azúcares añadidos'),/(ohne zuckerzusatz|no added sugar|senza zuccheri aggiunti|sin azucares anadidos)/i],
    ['lowsugar',tr('Zuckerarm','Low sugar','Pochi zuccheri','Bajo en azúcar'),/(zuckerarm|low sugar|pochi zuccheri|basso contenuto di zuccheri|bajo en azucar|bajo contenido de azucar)/i],
    ['wheatfree',tr('Ohne Weizen','Wheat-free','Senza frumento','Sin trigo'),/(ohne weizen|wheat-free|senza frumento|sin trigo)/i],
    ['peanutfree',tr('Ohne Erdnüsse','Peanut-free','Senza arachidi','Sin cacahuetes'),/(ohne erdnusse|ohne erdnüsse|peanut-free|senza arachidi|sin cacahuetes)/i],
    ['nutfree',tr('Ohne Schalenfrüchte','Nut-free','Senza frutta a guscio','Sin frutos secos'),/(ohne schalenfruchte|ohne schalenfrüchte|nut-free|senza frutta a guscio|sin frutos secos)/i]
  ];
  var toolbar=document.createElement('div');
  toolbar.className='ccs-toolbar';
  toolbar.innerHTML='<input class="ccs-search" type="search" aria-label="'+tr('Muster suchen','Search samples','Cerca campioni','Buscar muestras')+'" placeholder="'+tr('Muster suchen…','Search samples…','Cerca campioni…','Buscar muestras…')+'">'+
    '<button class="ccs-filter-toggle" type="button" aria-expanded="false">'+tr('Filter','Filters','Filtri','Filtros')+' <span class="ccs-filter-count"></span></button>'+
    '<select class="ccs-sort" aria-label="'+tr('Muster sortieren','Sort samples','Ordina campioni','Ordenar muestras')+'"><option value="featured">'+tr('Empfohlen','Recommended','In primo piano','Recomendado')+'</option><option value="az">A–Z</option><option value="za">Z–A</option></select>'+
    '<span class="ccs-result-count"><strong>0</strong> '+tr('Muster','samples','campioni','muestras')+'</span>';
  var advanced=document.createElement('section');
  advanced.className='ccs-advanced';
  advanced.setAttribute('aria-hidden','true');
  advanced.innerHTML='<div class="ccs-advanced__head"><h2 class="ccs-advanced__title">'+tr('Eigenschaften','Properties','Caratteristiche','Características')+'</h2><a class="ccs-advanced__close" href="#">'+tr('Schließen','Close','Chiudi','Cerrar')+'</a></div><div class="ccs-advanced__grid">'+filters.map(function(f){return '<label class="ccs-property"><input type="checkbox" value="'+f[0]+'"><span>'+f[1]+'</span></label>';}).join('')+'</div><div class="ccs-actions"><button class="ccs-reset" type="button">'+tr('Filter zurücksetzen','Reset filters','Azzera filtri','Restablecer filtros')+'</button></div>';
  tabs.parentNode.insertBefore(toolbar,tabs);
  tabs.parentNode.insertBefore(advanced,tabs);
  var empty=document.createElement('p');empty.className='ccs-no-results';empty.textContent=tr('Keine passenden Muster gefunden.','No matching samples found.','Nessun campione corrispondente.','No se encontraron muestras.');grid.parentNode.insertBefore(empty,grid.nextSibling);

  var search=toolbar.querySelector('.ccs-search');
  var toggle=toolbar.querySelector('.ccs-filter-toggle');
  var sort=toolbar.querySelector('.ccs-sort');
  var count=toolbar.querySelector('.ccs-result-count strong');
  var filterCount=toolbar.querySelector('.ccs-filter-count');
  var activeCategory='all';
  var original=cards.slice();
  function normalize(value){return String(value||'').normalize('NFD').replace(/[\u0300-\u036f]/g,'').replace(/\s+/g,' ').toLowerCase();}
  function text(card){return normalize(card.innerText||card.textContent||'');}
  function apply(){
    var q=normalize(search.value).trim();
    var chosen=[].slice.call(advanced.querySelectorAll('input:checked')).map(function(input){return input.value;});
    var shown=[];
    cards.forEach(function(card){
      var body=text(card),cats=' '+(card.getAttribute('data-cats')||'')+' ';
      var categoryOk=activeCategory==='all'||cats.indexOf(' '+activeCategory+' ')>-1;
      var propsOk=chosen.every(function(key){var spec=filters.filter(function(f){return f[0]===key;})[0];return spec&&spec[2].test(body);});
      var visible=categoryOk&&(!q||body.indexOf(q)>-1)&&propsOk;
      card.hidden=!visible;if(visible)shown.push(card);
    });
    if(sort.value!=='featured'){
      shown.sort(function(a,b){var aa=text(a),bb=text(b);return sort.value==='az'?aa.localeCompare(bb):bb.localeCompare(aa);}).forEach(function(card){grid.appendChild(card);});
    }else{original.forEach(function(card){grid.appendChild(card);});}
    count.textContent=shown.length;
    filterCount.textContent=chosen.length?'('+chosen.length+')':'';
    empty.classList.toggle('is-visible',shown.length===0);
  }
  function setPanel(open){advanced.classList.toggle('is-open',open);advanced.setAttribute('aria-hidden',open?'false':'true');toggle.setAttribute('aria-expanded',open?'true':'false');}
  toggle.addEventListener('click',function(){setPanel(!advanced.classList.contains('is-open'));});
  advanced.querySelector('.ccs-advanced__close').addEventListener('click',function(event){event.preventDefault();setPanel(false);});
  advanced.querySelector('.ccs-reset').addEventListener('click',function(){
    advanced.querySelectorAll('input').forEach(function(i){i.checked=false;});
    tabs.querySelectorAll('input[type="checkbox"],input[type="radio"]').forEach(function(tab){
      var raw=String(tab.value||tab.textContent||'').trim().toLowerCase();
      tab.checked=/^(all|alle|todas|todos|tutti|tutto|tutte)$/.test(raw);
    });
    activeCategory='all';search.value='';sort.value='featured';setPanel(false);apply();
  });
  advanced.querySelectorAll('input').forEach(function(i){i.addEventListener('change',apply);});
  search.addEventListener('input',apply);sort.addEventListener('change',apply);
  tabs.querySelectorAll('.ccm-tab,[data-f],[data-filter],input[type="checkbox"],button').forEach(function(tab){tab.addEventListener('click',function(){var raw=tab.getAttribute('data-f')||tab.getAttribute('data-filter')||tab.value||tab.textContent||'all';if(!raw||raw==='on'){var label=tab.closest&&tab.closest('label');raw=label?label.textContent:'all';}raw=String(raw).trim().toLowerCase();activeCategory=/^(all|alle|todas|todos|tutti|tutto|tutte)$/.test(raw)?'all':raw.normalize('NFD').replace(/[\u0300-\u036f]/g,'').replace(/[^a-z0-9]+/g,'-').replace(/^-|-$/g,'');setTimeout(apply,0);});});
  root.classList.add('ccs-enhanced');apply();
})();

(function(){
  'use strict';
  if(!/\/products\//i.test(location.pathname))return;
  var pathLocale=((location.pathname.match(/^\/(de|en|it|es)(?:\/|$)/i)||[])[1]||'').toLowerCase();
  var htmlLocale=(document.documentElement.lang||'').toLowerCase().split(/[-_]/)[0];
  var detailLocale=pathLocale||htmlLocale||(location.hostname.indexOf('donsnacks')>-1?'es':'de');
  var policyText=detailLocale==='en'?'Up to 25 free samples per order for approved B2B customers. New customers can request the sample package for €9.95 + VAT.':'Hasta 25 muestras gratuitas por pedido para clientes B2B aprobados. Nuevos clientes pueden solicitar el paquete de muestras por 9,95 € + IVA.';
  function cleanLateSampleContent(){
    var walker=document.createTreeWalker(document.body,NodeFilter.SHOW_TEXT),node,nodes=[];
    while((node=walker.nextNode()))nodes.push(node);
    nodes.forEach(function(textNode){
      var value=(textNode.nodeValue||'').replace(/\s+/g,' ').trim();
      if(!value)return;
      if(location.hostname.indexOf('donsnacks')>-1&&/hasta\s+10\s+muestras|nur\s+zusammen\s+mit\s+einer\s+regul[aä]ren\s+bestellung|only\s+with\s+a\s+regular\s+order/i.test(value)){
        textNode.nodeValue=policyText;
        return;
      }
      if(/^(?:€\s*0[,.]00|0[,.]00\s*€)(?:\s*[·–-].*)?$/i.test(value)){
        var holder=textNode.parentElement;
        if(holder&&holder.tagName!=='BUTTON')holder.classList.add('ccs-sample-price');
      }
    });
  }
  setTimeout(cleanLateSampleContent,1200);
  setTimeout(cleanLateSampleContent,3000);
})();

(function(){
  'use strict';
  if(!/\/products\//i.test(location.pathname))return;
  var pageText=(document.body.innerText||'').slice(0,9000);
  var sampleSignal=/(?:\b(?:sku|ref\.?|artikelnummer)\b[^\n]{0,40}(?:sample|muster|campione)|campione professionale b2b|muestra profesional b2b|gratismuster)/i;
  if(!sampleSignal.test(pageText)&&!/(?:campione|muestra|sample|muster)/i.test(location.pathname))return;

  document.body.classList.add('ccs-sample-detail');
  var zeroPrice=/^(?:€\s*0[,.]00|0[,.]00\s*€)(?:\s*[·–-].*)?$/i;
  var defaultTitle=/^default title$/i;
  var walker=document.createTreeWalker(document.body,NodeFilter.SHOW_TEXT);
  var textNodes=[],node;
  while((node=walker.nextNode()))textNodes.push(node);
  textNodes.forEach(function(textNode){
    var value=(textNode.nodeValue||'').replace(/\s+/g,' ').trim();
    if(!value)return;
    if(location.hostname.indexOf('donsnacks')>-1&&/hasta\s+10\s+muestras|nur\s+zusammen\s+mit\s+einer\s+regul[aä]ren\s+bestellung|only\s+with\s+a\s+regular\s+order/i.test(value)){
      var copyLocale=((location.pathname.match(/^\/(de|en|it|es)(?:\/|$)/i)||[])[1]||(document.documentElement.lang||'').toLowerCase().split(/[-_]/)[0]||'es').toLowerCase();
      textNode.nodeValue=copyLocale==='en'?'Up to 25 free samples per order for approved B2B customers. New customers can request the sample package for €9.95 + VAT.':'Hasta 25 muestras gratuitas por pedido para clientes B2B aprobados. Nuevos clientes pueden solicitar el paquete de muestras por 9,95 € + IVA.';
      return;
    }
    if(defaultTitle.test(value)){
      var titleHolder=textNode.parentElement;
      if(titleHolder)titleHolder.classList.add('ccs-default-variant');
    }else if(zeroPrice.test(value)){
      var priceHolder=textNode.parentElement;
      if(priceHolder&&priceHolder.tagName!=='BUTTON')priceHolder.classList.add('ccs-sample-price');
    }
  });

  var lang=(document.documentElement.lang||'').toLowerCase();
  var host=location.hostname.replace(/^www\./,'');
  var pathLocale=((location.pathname.match(/^\/(de|en|it|es)(?:\/|$)/i)||[])[1]||'').toLowerCase();
  var locale=pathLocale||lang.split(/[-_]/)[0];
  if(!/^(de|en|it|es)$/.test(locale))locale=host.indexOf('aperigusto')>-1?'it':(host.indexOf('donsnacks')>-1?'es':'de');
  var isIt=locale==='it';
  var isEn=locale==='en';
  var collection=host.indexOf('aperigusto')>-1?'/collections/campioni-b2b':(host.indexOf('donsnacks')>-1?'/collections/muestras-b2b':'/Muster');
  if(isEn)collection='/en'+collection;
  function label(de,en,it,es){return isEn?en:(isIt?it:(host.indexOf('donsnacks')>-1?es:de));}
  var main=document.querySelector('main,[id="MainContent"]');
  if(!main||document.querySelector('.ccs-sample-nav'))return;
  var nav=document.createElement('nav');
  nav.className='ccs-sample-nav';
  nav.setAttribute('aria-label',label('Musternavigation','Sample navigation','Navigazione campioni','Navegación de muestras'));
  nav.innerHTML='<a class="ccs-sample-nav__back" href="'+collection+'">\u2190 '+label('Zurück zu den Mustern','Back to samples','Torna ai campioni','Volver a las muestras')+'</a><a class="ccs-sample-nav__arrow ccs-prev" aria-label="'+label('Vorheriges Muster','Previous sample','Campione precedente','Muestra anterior')+'" aria-disabled="true">\u2039</a><a class="ccs-sample-nav__arrow ccs-next" aria-label="'+label('Nächstes Muster','Next sample','Campione successivo','Muestra siguiente')+'" aria-disabled="true">\u203a</a>';
  main.insertBefore(nav,main.firstChild);
  fetch(collection,{credentials:'same-origin'}).then(function(response){return response.ok?response.text():'';}).then(function(html){
    if(!html)return;
    var doc=new DOMParser().parseFromString(html,'text/html');
    var links=[].slice.call(doc.querySelectorAll('#ccm .ccm-card a[href*="/products/"]'));
    var paths=[],seen={};
    links.forEach(function(link){var path=new URL(link.href,location.origin).pathname.replace(/\/$/,'');if(!seen[path]){seen[path]=1;paths.push(path);}});
    var current=location.pathname.replace(/\/$/,'');
    var index=paths.indexOf(current);
    if(index<0)return;
    var prev=nav.querySelector('.ccs-prev'),next=nav.querySelector('.ccs-next');
    if(index>0){prev.href=paths[index-1];prev.removeAttribute('aria-disabled');}
    if(index<paths.length-1){next.href=paths[index+1];next.removeAttribute('aria-disabled');}
  }).catch(function(){});
})();
